export default {
  createdAt: 'Created at',
  note: 'Note',
};
